<template>
    <span class="text-success mr-2" v-if="pagamentoNotaFiscal.documentoId">
        <i
            class="fa fa-download fa-lg icon-button"
            title="Download da Nota Fiscal"
            @click.stop="downloadNotaFiscal()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        pagamentoNotaFiscal: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    methods: {
        downloadNotaFiscal() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .downloadNotaFiscal(this.pagamentoNotaFiscal.pagamentoId, this.pagamentoNotaFiscal.pagamentoNotaFiscalId)
                .then(response => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao baixar a nota fiscal!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            const blob = new Blob([response], {
                                type: response.type || 'application/pdf'
                            })
                            this.downloadFile(blob, this.getFileName())
                            this.$toast.success(
                                'Nota fiscal baixada com sucesso!',
                                'SUCESSO',
                                this.$toastConfig.success
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
                .catch(error => {
                    this.$store.dispatch('removeRequest')
                    this.$toast.error(
                        'Erro ao baixar a nota fiscal!',
                        'ERROR',
                        this.$toastConfig.error
                    )
                    console.error('Erro ao baixar nota fiscal:', error)
                })
        },

        downloadFile(blob, filename) {
            const link = document.createElement('a')
            const url = URL.createObjectURL(blob)
            link.href = url
            link.download = filename
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(url)
        },

        getFileName() {
            const notaFiscal = this.pagamentoNotaFiscal
            const numero = notaFiscal.numeroNota || 'sem-numero'
            const tipo = notaFiscal.tipo || 'NF'
            return `${tipo}-${numero}.pdf`
        }
    }
}
</script>
